<template>
  <PageTemplate>
    <h1 v-text="title" />
    <div class="row">
      <div class="col-md-12 d-flex">
        <v-card title="Facility Details">
          <template #header>
            <router-link
              to="/contact"
            >
              <v-icon type="edit" />
              Edit
            </router-link>
          </template>
          <v-definition-list
            :data="facilityDetails"
          />
        </v-card>
      </div>
      <!-- <div class="col-md-6 d-flex">
        <v-card title="Authorised Representative">
          <v-definition-list
            :data="authorisedRep"
          />
        </v-card>
      </div> -->
    </div>
    <v-card title="Sites">
      <v-table
        :table="table"
      />
    </v-card>
    <v-tabs v-if="isCurrentUserIsPrimaryAr">
      <v-tab
        name="Received Facility Documents"
        :selected="true"
      >
        <v-table
          ref="receivedDocumentTable"
          :table="received"
          :checkboxes-enabled="true"
          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'dateUploaded', type: 'asc'}
          }"
          @showDoc="previewDoc"
          @downloadDoc="downloadDoc"
        >
          <template #optional>
            <v-button
              color="primary"
              @click="downloadSelectedReceived"
            >
              Download Selected
            </v-button>
          </template>
        </v-table>
      </v-tab>
      <v-tab name="Submitted Facility Documents">
        <v-table
          ref="submittedDocumentTable"
          :table="submitted"
          :checkboxes-enabled="true"
          :sort-options="{
            enabled: true,
            initialSortBy: {field: 'dateUploaded', type: 'asc'}
          }"
          @showDoc="previewDoc"
          @downloadDoc="downloadDoc"
        >
          <template #optional>
            <v-button
              color="primary"
              @click="downloadSelectedSubmitted"
            >
              Download Selected
            </v-button>
          </template>
        </v-table>
        <v-button
          size="lg"
          @click="openUploadModal"
        >
          Upload Document
        </v-button>
      </v-tab>
    </v-tabs>
    <v-modal
      v-if="showUploadModal"
      @close="closeUploadModal"
    >
      <template #header>
        File Upload
      </template>
      <template v-if="file">
        <div
          v-if="fileConfirmed"
          class="row align-items-center"
        >
          <div class="col-lg-6">
            <v-fieldset
              v-model="uploadDescription"
              type="textarea"
              text="Details/Report Reference*"
              maxlength="255"
              @input="inputChange"
            />
            <div
              class="max-char-text"
            >
              (*mandatory field, 255 character maximum.)
            </div>
          </div>
          <div class="col-lg-6">
            <v-fileupload
              v-if="file"
              :file-name="file.name"
              :file-size="file.size | formatFileSize"
              @clear="fileRemoved"
            />
          </div>
          <v-spinner
            v-if="isUploading"
            :is-full="false"
          />
        </div>
        <div
          v-else
          class="text--center"
        >
          <p class="text--lg">
            Are you sure this is the file you want to upload to {{ title }}?
          </p>
          <p class="text--lg">
            <strong>{{ file.name }}</strong> {{ file.size | formatFileSize }}
          </p>
          <v-button-group is-inline>
            <v-button
              v-if="file"
              has-min-width
              @click="fileConfirmed = true"
            >
              Yes
            </v-button>
            <v-button
              color="secondary"
              has-min-width
              @click="fileRemoved"
            >
              No
            </v-button>
          </v-button-group>
        </div>
      </template>
      <v-dropzone
        v-else
        additional-msg="(Special characters (!@#$%^&*_+/) must not be used in filenames. Multiple files are best uploaded as a zipped file folder.)"
        @file-added="fileAdded"
        @file-error="uploadError"
      />
      <template #footer>
        <v-button-group is-right>
          <v-button
            v-if="file && fileConfirmed"
            size="lg"
            has-min-width
            @click="uploadDocument"
          >
            Finish
          </v-button>
          <v-button
            color="secondary"
            size="lg"
            has-min-width
            @click="closeUploadModal"
          >
            Cancel
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
  </PageTemplate>
</template>
<script>
import PageTemplate from "../templates/Page/index.vue";
import Fieldset from "@/molecules/Fieldset";
import Card from "@/molecules/Card";
import Table from "@/molecules/Table";
import DefinitionList from "@/atoms/DefinitionList";
import Icon from "@/atoms/Icon";
import { columnFilter, columnSort, stateList, buildBreadCrumb, buildDefinitionList, dateSort_ddmmyy } from "../common/tableFunctions"
import routes from "@/common/routes"
import { GET_FACILITY } from "@/store/actions.type";
import Tabs from "@/molecules/Tabs";
import Tab from "@/atoms/Tab";
import Button from "@/atoms/Button";
import Spinner from "@/atoms/Spinner";
import Modal from "@/atoms/Modal";
import Dropzone from "@/molecules/Dropzone";
import ButtonGroup from "@/molecules/ButtonGroup";
import FileUpload from '@/molecules/FileUpload'
import {
  GET_SITE,
  GET_FACILITY_DOCUMENTS,
  UPDATE_SITE,
  UPLOAD_FACILITY_DOCUMENT,
  PREVIEW_FACILITY_DOCUMENT,
  DOWNLOAD_FACILITY_DOCUMENT,
  DOWNLOAD_FACILITY_DOCUMENTS
} from "@/store/actions.type";
// import Input from "@/atoms/Input";
import {mapState} from "vuex";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/airbnb.css";
import {formatFileSize, formatDate} from "../common/formatting";
import constants from "../common/constants";

export default {
  name: "Facility",
  components: {
    "v-table": Table,
    "v-definition-list": DefinitionList,
    "v-card": Card,
    "v-icon": Icon,
    "v-fieldset": Fieldset,
    "v-tabs": Tabs,
    "v-tab": Tab,
    "v-definition-list": DefinitionList,
    "v-card": Card,
    "v-button": Button,
    "v-modal": Modal,
    "v-button-group": ButtonGroup,
    "v-dropzone": Dropzone,
    // "v-input": Input,
    "v-spinner": Spinner,
    'v-fileupload': FileUpload,
    PageTemplate,
  },
  filters: {
    formatFileSize: formatFileSize
  },
  data(){
    return {
      title: 'Facility',
      breadcrumbs: [],
      table: {
        columns: [
          {
            label: 'Site Name',
            field: 'site_name',
            link: true,
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'Search name',
              filterFn: columnFilter
            },
          },
          {
            label: 'Site Number',
            field: 'site_id',
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'Site ID',
              filterFn: columnFilter
            },
          },
          {
            label: 'Status',
            field: 'site_status',
            badge: true,
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'All',
              filterDropdownItems: ['In progress', 'Planned','Complete','Cancel'],
              filterFn: columnFilter
            },
          },
          {
            label: 'State',
            field: 'state',
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'All',
              filterDropdownItems: stateList,
              filterFn: columnFilter
            },
          },
          {
            label: 'Suburb/City',
            field: 'suburb',
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'Search suburb',
              filterFn: columnFilter
            }
          },
          {
              label: 'Actions',
              field: 'actions',
              actions: 'edit',
              sortable: false,
              thClass: 'shrink-cell',
            tdClass: 'no-wrap',
          }
        ],
        rows: [],
        totalRecords: 0
      },
      authorisedRep:[],
      facilityDetails:[],
      received: {
          columns: [
            {
              label: 'data',
              field: 'data',
              hidden: true
            },
            {
              label: 'Document Name',
              field: 'docName',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Enter Document Name',
                filterFn: columnFilter
              },
            },
            {
              label: 'Description',
              field: 'desc',
              sortable: false,
              thClass: 'shrink-cell',

            },
            {
              label: 'Date Uploaded',
              field: 'dateUploaded',
              sortFn: dateSort_ddmmyy,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Date',
                filterFn: columnFilter
              },
            },
            {
              label: 'Actions',
              field: 'actions',
              sortable: false,
              actions: 'view_and_download',
              thClass: 'shrink-cell',
              tdClass: 'no-wrap',
            },
          ],
          rows: [],
          totalRecords: 0
      },
      submitted: {
        columns: [
          {
            label: 'Document Name',
            field: 'docName',
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'Enter Document Name',
              filterFn: columnFilter
            },
          },
          {
            label: 'Description',
            field: 'desc',
            sortable: false,
            thClass: 'shrink-cell'
          },
          {
            label: 'Date Uploaded',
            field: 'dateUploaded',
            sortFn: dateSort_ddmmyy,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'Date',
              filterFn: columnFilter
            },
          },
          {
            label: 'Uploaded By',
            field: 'uploadedBy',
            sortable: false,
            thClass: 'shrink-cell',
            filterOptions: {
              enabled: true,
              placeholder: 'Name',
              filterFn: columnFilter
            },
          },
          {
            label: 'Actions',
            field: 'actions',
            sortable: false,
            actions: 'view_and_download',
            thClass: 'shrink-cell',
            tdClass: 'no-wrap',
          },
        ],
        rows: [],
        totalRecords: 0
      },
      showUploadModal: false,
      modalHasFile: false,
      uploadDescription: "",
      file: null,
      isUploading: false,
      fileConfirmed: false,
      facilityId: null,
      isCurrentUserIsPrimaryAr: false
    };
  },
  computed: {
    facilityDocuments() { 
      return this.$store.state.facilityDocuments.facilityDocuments;
    },
    ...mapState({
      currentUser: state => state.auth.user,
    })
  },
  mounted() {
    this.getFacility(this.$route.params.id);
    this.getFacilityDocuments(this.$route.params.id);
    this.facilityId = this.$route.params.id;
  },
  methods:{
    updateBreadCrumb: function(fn) {
       let breadcrumbs = [];
        breadcrumbs['Dashboard'] = routes.DASHBOARD;
        breadcrumbs['Facilities/Sites'] = routes.FACILITIES;
        breadcrumbs[this.title + ' - ' + fn ] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
    },
    getFacility: function(facility_id) {
      this.$store.dispatch(GET_FACILITY,{facility_id}).then(response => {
        let res = response.data;
        this.title = res[0].facility.name;
        this.updateBreadCrumb(res[0].facility.name);
        let authRep = [];
        let facilityDetails = [];


        facilityDetails['Facility Name'] = res[0].facility.name;
        facilityDetails['Facility Number'] = res[0].facility.facility_number;
        //TODO Fix once Contact details determined
        //facilityDetails['Phone'] = JSON.parse(res[0].facility.contacts).contacts[0].phone;
        facilityDetails['Email Address'] = res[0].facility.billing_email;
        facilityDetails['Address'] = res[0].facility.address;
        facilityDetails['Suburb'] = res[0].facility.suburb;
        facilityDetails['Post Code'] = res[0].facility.post_code;
        facilityDetails['State'] = res[0].facility.country !== null ? (res[0].facility.state + ', ' + res[0].facility.country):(res[0].facility.state);
        this.facilityDetails = buildDefinitionList(facilityDetails);
        this.isCurrentUserIsPrimaryAr = this.currentUser.id == res[0].facility.primary_ar;

        //TODO Fix once Contact details determined
        //authRep['Name'] = JSON.parse(res[0].facility.contacts).contacts[0].name;
        //authRep['Phone number'] = JSON.parse(res[0].facility.contacts).contacts[0].phone;
        //authRep['Email Address'] = res[0].facility.billing_email;
        this.authorisedRep = buildDefinitionList(authRep);

        this.table.rows = this.formatSites(res);
        this.table.totalRecords = response.data.total;

        //filter unique status
        const arr = this.table.rows.map(i => i.status);
        this.table.columns[2].filterOptions.filterDropdownItems = Array.from([...new Set(arr.filter(
            function(el){
                return el != '-';
            }
        ))]);

        // //filter unique state
        const arr2 = this.table.rows.map(i => i.state.value);
        this.table.columns[3].filterOptions.filterDropdownItems  = Array.from([...new Set(arr2.filter(
            function(el){
                return el != '-';
            }
        ))]);
      });
    },
    formatSites: function(list){
      list.map((site) => {
        let site_name = {};
        let status = {};
        let site_id = {};
        let state = {};
        let suburb = {};

        site_id.value = site.site_number;
        site_name.value = site.name;
        site_name.link = routes.SITE + site.id;
        status.value = site.status;
        status.type = site.status === 'In Progress' ? 'accent':null;
        state.value = site.state;
        suburb.value = site.suburb;

        site.site_id = site_id;
        site.site_name = site_name;
        site.site_status = status;
        site.state = state;
        site.suburb = suburb;
      });
      return list;
    },
    getFacilityDocuments: function (facilityId) {
      this.$store.dispatch(GET_FACILITY_DOCUMENTS, {facilityId}).then(response => {
        this.received.rows = this.facilityDocuments.received;
        this.submitted.rows = this.facilityDocuments.submitted;
      });
    },
    previewDoc(params) {
      // If Microsoft Edge below 50 version
      if(window.navigator && window.navigator.msSaveOrOpenBlob) {
          this.downloadDoc(params);
          return;
      }
      let url = params;
      this.$store.dispatch(PREVIEW_FACILITY_DOCUMENT, {url})
        .then(response => {
            window.open(response, '_blank');
        })
        .catch(error => {
          this.$notify({
            title: 'Error',
            text: error,
            type: 'error'
          });
        })
  },
  inputChange(val) {
    this.uploadDescription = val;
  },
  downloadDoc(params) {
      this.$store.state.auth.isLoading = true;
      let url = params;
      this.$store.dispatch(DOWNLOAD_FACILITY_DOCUMENT, {url})
        .then(response => {
          return response;
        }).finally(() => {
          this.$store.state.auth.isLoading = false;
        });
    },
    downloadSelected(rows) {
      let selectedIds = rows.map( function (row) {
        return row.data.id;
      });
      this.$store.state.auth.isLoading = true;
      this.$store.dispatch(DOWNLOAD_FACILITY_DOCUMENTS, {selectedIds})
        .then(response => {
          return response;
        })
        .catch(error => {
          this.$notify({
            title: 'Error',
            text: error,
            type: 'error'
          });
        }).finally(() => {
          this.$store.state.auth.isLoading = false;
        });
    },
    downloadSelectedReceived() {
      let selectedRows = this.$refs.receivedDocumentTable.$refs.table.selectedRows;
      if(selectedRows.length > 0){
          this.downloadSelected(selectedRows);
      }
    },
    downloadSelectedSubmitted() {
      let selectedRows = this.$refs.submittedDocumentTable.$refs.table.selectedRows;
        if(selectedRows.length > 0){
            this.downloadSelected(selectedRows);
        }
    },
    openUploadModal() {
      this.showUploadModal = true;
    },
    closeUploadModal() {
      this.file = null;
      this.showUploadModal = false;
      this.fileConfirmed = false;
      this.description = '';
      this.uploadDescription = '';
    },
    fileAdded(file) {
      this.file = file;
    },
    fileRemoved(file) {
      this.fileConfirmed = false;
      this.file = null;
    },
    uploadDocument: function () {
      this.isUploading = true;
      let file = this.file;
      let facilityId = this.facilityId;
      let description = this.uploadDescription;
      this.$store.dispatch(UPLOAD_FACILITY_DOCUMENT, {file, facilityId, description})
        .then(response => {
          this.isUploading = false;
          this.getFacilityDocuments(this.facilityId);
          this.closeUploadModal();
          this.uploadDescription = '';
        })
        .catch(error => {
          this.isUploading = false;
          this.description = '';
          this.uploadDescription = '';
          this.$notify({
            title: 'Error',
            text: error,
            type: 'error'
          });
        });
    },
    uploadError: function (errors) {
      for (var i = errors.length - 1; i >= 0; i--) {
        this.$notify({
          title: 'Error',
          text: errors[i],
          type: 'error'
        });
      }
    },
  }
}
</script>

